export default "__VITE_ASSET__DS98kF$s__"